import { createModule } from '@dynapp/wc-api-generic'

export default createModule({
  entitySingular: 'productoption',
  entityPlural: 'productoptions',
  dataObject: 'dync-appshop-web',
  mode: process.env.NODE_ENV,
  state: {
    publishable: true
  }
});
